

















































































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import ZenButton from '@reciprocity/button';
import { BButtonGroup, BDropdown, BDropdownItemButton, BDropdownGroup, BDropdownDivider } from 'bootstrap-vue';
import Actions from '../actions/Actions.vue';
import { ZenFilter } from '@/components/listing/components/filters/types';
import { DataRow } from '@/components/listing/types';

export default Vue.extend({
  name: 'BulkEdit',
  components: {
    ZenButton,
    BButtonGroup,
    BDropdown,
    BDropdownItemButton,
    BDropdownGroup,
    BDropdownDivider,
    Actions,
  },
  model: {
    prop: 'selectedObjects',
    event: 'select',
  },
  props: {
    data: {
      type: Array as () => DataRow[],
      default: [],
    },
    selectedObjects: {
      type: Array,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    activeColumns: {
      type: Array as () => string[],
      required: true,
    },
    activeFilters: {
      type: Array as () => ZenFilter[],
      required: true,
    },
    sort: {
      type: Object as () => SortBy,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['featureFlags']),
    selectedObjectIds() {
      return this.selectedObjects.map(el => el.id);
    },
    selectedObjectSlugs() {
      return this.selectedObjects.map(el => el.slug.value);
    },
    canCreateTaskForObjects() {
      return this.selectedObjects.some(el => el.permissions.canCreateTask);
    },
    canMapUnmapObjects() {
      return this.selectedObjects.some(el => el.permissions.canMap);
    },
    canDeleteObjects() {
      return this.selectedObjects.some(el => el.permissions.canDelete);
    },
    canCloseObjects() {
      return this.selectedObjects.some(el => el.permissions.surveyResponses.canClose);
    },
    scoringEnabled() {
      return this.featureFlags.risk_bulk_scoring;
    },
    sortedColumns() {
      const PRIMARY_COLUMNS = ['status', 'assignee', 'tags', 'owner'];

      return this.columns.reduce(
        (sorted: any, col: any) => {
          if (PRIMARY_COLUMNS.includes(col.name)) {
            sorted.primary.push(col);
          } else if (this.activeColumns.includes(col.name)) {
            sorted.active.push(col);
          } else {
            sorted.other.push(col);
          }
          return sorted;
        },
        {
          // Most edited attributes
          primary: [],
          // Attrs visible in listing
          active: [],
          // Rest of attributes
          other: [],
        }
      );
    },
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
  },
  apollo: {
    columns: {
      query: require('@/graphql/listing/Columns.gql'),
      variables() {
        return {
          type: this.objectType,
          context: 'SOR_LISTING',
        };
      },
      update({ objectType }) {
        const columns = objectType.attrs.filter(attr => attr.sorListing && attr.sorBulkEditing);
        return columns.map(col => {
          return {
            ...col,
            // TODO: Required for presenter fetching. Refactor with columnMeta
            key: col.name,
            label: col.displayName,
            customAttributeType: col.customAttributeType,
            sortable: col.sortable,
            editable: col.sorEditing,
            bulkEditable: col.sorBulkEditing,
          };
        });
      },
      error() {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      },
    },
  },
});
